import { Component, OnInit } from '@angular/core';
import { AuthService } from '../auth.service';
import { UntypedFormGroup, UntypedFormBuilder, Validators, AbstractControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { UserService } from '../../services/user.service';
import { PasswordRule, passwordRules } from '../password-rules';

@Component({
    selector: 'app-reset-password',
    templateUrl: './reset-password.component.html',
    styleUrls: ['./reset-password.component.scss', '../password-rules.scss'],
    host: { 'class': 'login' },
    standalone: false
})
export class ResetPasswordComponent implements OnInit {

  resetForm: UntypedFormGroup;
  submitted = false;
  serverError: any = '';
  rules: PasswordRule[] = [];

  constructor(private authS: AuthService, private fb: UntypedFormBuilder, private router: Router, private userSer: UserService,
              private route: ActivatedRoute) { }

  ngOnInit() {
    if (this.route.snapshot.queryParamMap.get('expired')) {
      this.serverError = 'Your password has expired. Please choose a new one.';
    }
    this.resetForm = this.fb.group({
      current_password: ['', [Validators.required]],
      password: ['', [Validators.required, Validators.minLength(8)]],
      confirm_password: ['', [Validators.required, Validators.minLength(8)]]
    });
    const user = this.userSer.getUserData() || null;
    const updateRules = () => {
      this.rules = passwordRules(this.f.password.value, this.f.confirm_password.value, user, true);
    };
    updateRules();
    this.resetForm.valueChanges.subscribe(updateRules);
  }

  // convenience getter for easy access to form fields
  get f() { return this.resetForm.controls; }

  onSubmit() {
    if (this.resetForm.invalid) {
      this.submitted = true;
      return;
    } else {
      const data = new FormData();
      if (this.resetForm.value.password !== this.resetForm.value.confirm_password) {
        this.serverError = 'Password and Confirm must be same.';
        return;
      } else {
        this.serverError = '';
      }
      data.append('current_password', this.resetForm.value.current_password);
      data.append('password', this.resetForm.value.password);
      this.authS.sendResetPassword(data).subscribe((data: any) => {
        if (data.status) {
          // Survives logout() clearing localStorage; the login page shows the confirmation once.
          sessionStorage.setItem('password_changed', '1');
          this.authS.logout();
        } else {
          this.serverError = data.error;
        }
      });
    }
  }

}
